import { boxTruckEquipment } from './box-truck.ts'
import { bulkEquipment } from './bulk.ts'
import type { EquipmentTypeDefinition } from './constants.ts'
import { drayageEquipment } from './drayage.ts'
import { dryVanEquipment } from './dry-van.ts'
import { flatbedEquipment } from './flatbed.ts'
import { intermodalEquipment } from './intermodal.ts'
import { defaultAccessorials } from './internal.ts'
import { refrigeratedEquipment } from './refrigerated.ts'
import { straightTruckEquipment } from './straight-truck.ts'

export const equipmentTypes: EquipmentTypeDefinition[] = [
  ...dryVanEquipment,
  ...refrigeratedEquipment,
  ...boxTruckEquipment,
  ...straightTruckEquipment,
  ...bulkEquipment,
  ...drayageEquipment,
  ...intermodalEquipment,
  ...flatbedEquipment,
  {
    key: 'air-freight',
    name: 'Air freight',
    accessorialTypes: defaultAccessorials,
    workflows: ['truckload'],
    mode: 'truckload',
  },
  {
    key: 'consolidated',
    name: 'Consolidated',
    accessorialTypes: defaultAccessorials,
    workflows: ['truckload'],
    mode: 'truckload',
  },
  {
    key: 'curtain-side-van',
    name: 'Curtain side van',
    accessorialTypes: defaultAccessorials,
    workflows: ['truckload'],
    mode: 'truckload',
  },
  {
    key: 'logistics-van-53',
    name: "Logistics van 53'",
    accessorialTypes: defaultAccessorials,
    workflows: ['truckload'],
    mode: 'truckload',
  },
  {
    key: 'ltl',
    name: 'Less than truckload',
    workflows: ['ltl'],
    mode: 'ltl',
    accessorialTypes: ['protect-from-freezing', 'single-shipment'],
  },
  {
    key: 'parcel',
    name: 'Parcel',
    workflows: ['parcel'],
    mode: 'parcel',
    accessorialTypes: [],
  },
  {
    key: 'padded-van',
    name: 'Padded van',
    workflows: ['truckload'],
    mode: 'truckload',
    accessorialTypes: defaultAccessorials,
  },
  {
    key: 'partial-dry-van',
    name: 'Partial dry van',
    accessorialTypes: [...defaultAccessorials, 'liftgate'],
    workflows: ['truckload', 'ltl'],
    mode: 'truckload',
  },
  {
    key: 'power-only',
    name: 'Power only',
    accessorialTypes: defaultAccessorials,
    workflows: ['truckload'],
    mode: 'truckload',
  },
  {
    key: 'pup',
    name: 'Pup',
    accessorialTypes: defaultAccessorials,
    workflows: ['ltl'],
    mode: 'ltl',
  },
  {
    key: 'refrigerated-ltl',
    name: 'Refrigerated LTL',
    workflows: ['ltl'],
    mode: 'ltl',
  },
  {
    key: 'sprinter-van',
    name: 'Sprinter van',
    accessorialTypes: defaultAccessorials,
    workflows: ['truckload', 'ltl'],
    mode: 'truckload',
  },
  {
    key: 'tanker',
    name: 'Tanker',
    accessorialTypes: defaultAccessorials,
    workflows: ['truckload'],
    mode: 'truckload',
  },
  {
    key: 'volume-ltl',
    name: 'Volume LTL',
    workflows: ['ltl'],
    mode: 'ltl',
  },
]
